import { Button } from '@/components/ui/button'
import { FieldError } from '@/components/ui/field-error'
import { Textarea } from '@/components/ui/textarea'
import { BROKER_NOTE_MAX_LENGTH } from '@/models/broker'

interface BrokerNoteFormProps {
  brokerFirstName: string
  draft: string
  onDraftChange: (draft: string) => void
  onSubmit: () => void
  isPending: boolean
  isError: boolean
}

/** The note box and Send button, shared by the desktop popover and the mobile sheet. */
export function BrokerNoteForm({
  brokerFirstName,
  draft,
  onDraftChange,
  onSubmit,
  isPending,
  isError,
}: BrokerNoteFormProps) {
  return (
    <form
      className="flex flex-col gap-3"
      onSubmit={(event) => {
        event.preventDefault()
        onSubmit()
      }}
    >
      <Textarea
        aria-label={`Note for ${brokerFirstName}`}
        placeholder="Ask about a quote, or anything else"
        value={draft}
        onChange={(event) => onDraftChange(event.target.value)}
        maxLength={BROKER_NOTE_MAX_LENGTH}
        disabled={isPending}
        aria-invalid={isError || undefined}
        className="min-h-24"
      />
      {isError && (
        <div role="alert">
          <FieldError message="We couldn't send your note. Try again." />
        </div>
      )}
      <Button
        type="submit"
        className="text-md self-end"
        disabled={!draft.trim()}
        loading={isPending ? 'Sending…' : undefined}
      >
        Send note
      </Button>
    </form>
  )
}
